module.exports = __webpack_public_path__ + "img/unlocking_illustration.0d6b9f2.png";